import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AUTH_SPLIT_LAYOUT_CONFIG, AuthSplitLayoutConfig } from './auth-split-layout.interface';

@Component({
  selector: 'aura-auth-split-layout',
  templateUrl: './auth-split-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  host: {
    class: 'flex flex-col flex-1 w-full h-full',
  },
})
export class AuraAuthSplitLayoutComponent {
  private readonly config = inject<AuthSplitLayoutConfig | null>(AUTH_SPLIT_LAYOUT_CONFIG, {
    optional: true,
  });

  // Form side inputs
  readonly title = input<string>();
  readonly subtitle = input<string>();
  readonly showLogo = input<boolean>(true);
  readonly appName = input<string>();
  readonly logoUrl = input<string>();
  readonly logoAlt = input<string>();
  readonly logoLink = input<string>();

  // Hero side inputs
  readonly showHero = input<boolean>(true);
  readonly heroTitle = input<string>();
  readonly heroSubtitle = input<string>();
  readonly heroDescription = input<string>();
  readonly heroSocialProof = input<string>();

  // Computed values with fallback to injected config or defaults
  protected readonly resolvedAppName = computed(() =>
    (this.appName() ?? this.config?.appName ?? 'ETXE').toUpperCase(),
  );

  protected readonly resolvedLogoUrl = computed(
    () => this.logoUrl() ?? this.config?.logoUrl ?? '/images/logo/logo.svg',
  );

  protected readonly resolvedLogoAlt = computed(
    () => this.logoAlt() ?? this.config?.logoAlt ?? this.resolvedAppName(),
  );

  protected readonly resolvedLogoLink = computed(() => this.logoLink() ?? this.config?.logoLink ?? '/');

  protected readonly resolvedHeroTitle = computed(
    () => this.heroTitle() ?? this.config?.heroTitle ?? 'Bienvenue',
  );

  protected readonly resolvedHeroSubtitle = computed(
    () => this.heroSubtitle() ?? this.config?.heroSubtitle ?? '',
  );

  protected readonly resolvedHeroDescription = computed(
    () =>
      this.heroDescription() ?? this.config?.heroDescription ?? 'Accédez à votre espace en toute sécurité.',
  );

  protected readonly resolvedHeroSocialProof = computed(
    () => this.heroSocialProof() ?? this.config?.heroSocialProof ?? '',
  );
}
